import { supabase } from '../supabaseClient.js';
import { templates } from '../constants/templates.js';

// Idempotent: profile rows are now created by the on_auth_user_created DB
// trigger, so this can be reached more than once per account (emailVerify,
// login self-heal, onboarding init) — only the first call inserts.
export const seedDefaultTemplates = async (userid) => {
  const { data: existing, error: checkError } = await supabase
    .from('templates')
    .select('id')
    .eq('userid', userid)
    .eq('is_base_template', true)
    .limit(1);
  if (checkError) {
    console.error('Error checking default templates:', checkError);
    return;
  }
  if (existing && existing.length > 0) return;

  const formattedTemplates = templates.map(template => ({
    title: template.title,
    content: template.content,
    userid: userid,
    default: template.title === 'Clinical Psychology Assessment Template' ? 'report' : null,
    is_base_template: true
  }));

  const { error: insertError } = await supabase
    .from('templates')
    .insert(formattedTemplates);
  if (insertError) {
    console.error('Error inserting default templates:', insertError);
  }
};
